
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { MapsHotelsService } from '../../services/maps-hotels/maps-hotels.service';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { MapsHotelsModel } from '../../models/maps-hotels-model';
import { SeoMetaService } from 'src/app/modules/aa-core/services/seo-meta-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { BaseRouterComponent } from 'src/app/modules/aa-core/components/base-router/base-router.component';
import { GoogleMapOptionsEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { AppError } from 'src/app/core/models/constants';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Component({
    selector: 'app-maps',
    templateUrl: './maps-hotels.component.html',
    styleUrls: ['./maps-hotels.component.scss'],
    standalone: false
})
export class MapsHotelsComponent extends BaseRouterComponent implements OnInit, OnDestroy {

  public mapsHotelsModel: MapsHotelsModel;
  public locationModel: AALocationModel;

  constructor(private mapsHotelService: MapsHotelsService,
    public appService: AppService,
    public seoService: SeoMetaService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public eventServices: EventsService,
    public appUtilityService: AppUtilityService) {
    super(activatedRoute, router, appUtilityService, seoService);

    this.appService.routerType = this.routerType = AARouterURL.MAP_HOTELS;
    this.mapsHotelsModel = this.mapsHotelService.mapsHotelsModel;
    this.locationModel = this.mapsHotelService.mapsHotelsModel.locationModel;
  }

  ngOnInit() {
    this.applySiteTag();
    this.loadParams();
    this.applySEO();
  }

  public initMap(params: any): void {
    // console.log("*******Maps & Hotel", params);
    this.mapsHotelService.initMap(params);
  }

  public onWindowResize(): void {
    this.mapsHotelService.loadDefaultMapOptions(500);
  }

  ngOnDestroy() {
    this.unSubscribeObservableEvents();
    this.mapsHotelService.destroy(GoogleMapType.MAPS);
    this.eventServices.dispatch(GoogleMapOptionsEvents.CLEAR_CLRSTER_DATA);
  }

  onFindLocation($event) {
    this.mapsHotelService.updateRouterURL();
    // this.mapsHotelService.loadMapData(GoogleMapType.MAPS, true);
  }

  mapOptionsChanged(event) {
    this.mapsHotelService.updateMapOptions();
  }

  get isLocationFeature() {
    return this.locationModel.errorMessage === AppError.LOCATION_ACCESS_FEATURE_TURNON ? true : false;
 }
}
